import apiService from "../ApiService";

const entitlementUnsubscribe = (uuid: string) => {
  return apiService.post<void>({
    path: `public/account/entitlements/${uuid}/unsubscribe`,
    requiresAuthPolicy: "user",
    crm: true,
  });
};
export { entitlementUnsubscribe };
